<template>
  <div>
    <!--
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ page.title }}</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ page.desc }}
      </p>
    </div>
    -->
    <div class="row">
      <div class="col-lg-12">
        <!-- 端口状态信息 -->
        <block-cntr
          :btitle="page.blkTitle.portStatusTable"
          style="height: 100%"
        >
          <!-- 按钮 -->
          <div class="form-inline" style="height: 35px">
            <span style="float: left">
              <div @click="editSelectRow" class="btn" style="padding: 0px">
                <i class="fa fa-edit page-tableaction" title="edit"></i>
              </div>
              <div @click="loadport" class="btn" style="padding: 0px">
                <i class="fa fa-refresh page-tableaction" title="refresh"></i>
              </div>
            </span>
          </div>
          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th width="40px">
                  <input
                    type="checkbox"
                    @change="selectall()"
                    v-model="selall"
                    id="idSelectAll"
                  />
                  <label for="idSelectAll"></label>
                </th>
                <th
                  v-for="(value, key) in portStatusTable.title"
                  :key="key"
                  :title="value"
                  :style="{
                    width:
                      key === 'desc' || key === 'tagvlan' || key === 'untagvlan'
                        ? '150px'
                        : key === 'speed' || key === 'pvid' || key === 'mode'
                        ? '100px'
                        : 'auto',
                  }"
                >
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody style="height: 300px">
              <tr
                v-for="row in portStatusTable.data"
                :key="row.port"
                :class="{
                  info: row['rowStatus'] === 'edit',
                }"
                @dblclick="editDoubleClickRow(row)"
                @click="
                  row.selected =
                    row.rowStatus === '' ? !row.selected : row.selected
                "
                style="
                  -moz-user-select: none; /*火狐*/
                  -webkit-user-select: none; /*webkit浏览器*/
                  -ms-user-select: none; /*IE10*/
                  -khtml-user-select: none; /*早期浏览器*/
                  user-select: none;
                "
              >
                <td width="40px">
                  <div v-if="row.rowStatus === ''">
                    <input type="checkbox" v-model="row.selected" />
                    <label></label>
                  </div>
                  <div v-else class="revocate" @click.stop="undoRow(row)">
                    <i class="fa fa-undo"></i>
                  </div>
                </td>
                <td
                  v-for="(value, key) in row"
                  :key="key"
                  :title="value"
                  :style="{
                    width:
                      key === 'desc' || key === 'tagvlan' || key === 'untagvlan'
                        ? '150px'
                        : key === 'speed' || key === 'pvid' || key === 'mode'
                        ? '100px'
                        : 'auto',
                  }"
                  v-show="
                    key !== 'rowStatus' &&
                    key !== 'selected' &&
                    key !== 'newdesc' &&
                    key !== 'newshutdown' &&
                    key !== 'speedlist' &&
                    key !== 'newspeed' &&
                    key !== 'newpri' &&
                    key !== 'newpvid' &&
                    key !== 'newmode' &&
                    key !== 'newtagvlan' &&
                    key !== 'newuntagvlan'
                  "
                >
                  <!-- 端口描述编辑 -->
                  <div v-if="key === 'desc' && row.rowStatus === 'edit'">
                    <span
                      style="position: relative; display: block"
                      :class="{ 'has-error': input_desc_check(row) }"
                    >
                      <input
                        type="text"
                        v-model="row.newdesc"
                        class="form-control table-edit"
                        maxlength="128"
                        placeholder="STRING<1-128>"
                      />
                      <i
                        class="form-control-feedback glyphicon"
                        :class="{ 'glyphicon-remove': input_desc_check(row) }"
                        style="height: 20px; line-height: 20px; width: 20px"
                      ></i>
                      <small
                        class="help-block"
                        :style="{
                          display: input_desc_check(row) ? 'block' : 'none',
                        }"
                        >{{ input_desc_check(row) }}</small
                      >
                    </span>
                  </div>
                  <!-- 端口开关配置 -->
                  <div
                    v-else-if="
                      key === 'shutdown' && row['rowStatus'] === 'edit'
                    "
                  >
                    <input
                      type="checkbox"
                      v-model="row['newshutdown']"
                      class="form-control table-edit"
                      :id="row['port']"
                    />
                    <label :for="row['port']">{{ row["newshutdown"] }}</label>
                  </div>
                  <!-- 端口速率配置 -->
                  <div
                    v-else-if="
                      key === 'speed' &&
                      row['rowStatus'] === 'edit' &&
                      (row['port'][0] === 'e' || row['port'][0] === 'E')
                    "
                  >
                    <select
                      class="form-control table-edit"
                      v-model="row['newspeed']"
                    >
                      <option
                        v-for="(value, key) in row['speedlist']"
                        :key="key"
                        :value="value"
                      >
                        {{
                          value === "1000" || value === "10000"
                            ? value + " Mbps"
                            : value
                        }}
                      </option>
                    </select>
                  </div>
                  <!-- 端口优先级配置 -->
                  <div
                    v-else-if="
                      key === 'pri' &&
                      row['rowStatus'] === 'edit' &&
                      (row['port'][0] === 'e' || row['port'][0] === 'E')
                    "
                  >
                    <select
                      class="form-control table-edit"
                      v-model="row['newpri']"
                    >
                      <option
                        v-for="(value, key) in 8"
                        :key="key"
                        :value="value - 1"
                      >
                        {{ value - 1 }}
                      </option>
                    </select>
                  </div>
                  <!-- 端口pvid 编辑 -->
                  <div
                    v-else-if="
                      key === 'pvid' &&
                      row.rowStatus === 'edit' &&
                      (row['port'][0] === 'e' || row['port'][0] === 'E')
                    "
                  >
                    <span
                      style="position: relative; display: block"
                      :class="{ 'has-error': input_pvid_check(row) }"
                    >
                      <input
                        type="text"
                        v-model="row.newpvid"
                        class="form-control table-edit"
                        maxlength="4"
                      />
                      <i
                        class="form-control-feedback glyphicon"
                        :class="{ 'glyphicon-remove': input_pvid_check(row) }"
                        style="height: 20px; line-height: 20px; width: 20px"
                      ></i>
                      <small
                        class="help-block"
                        :style="{
                          display: input_pvid_check(row) ? 'block' : 'none',
                        }"
                        >{{ input_pvid_check(row) }}</small
                      >
                    </span>
                  </div>
                  <!-- 端口模式编辑 -->
                  <div
                    v-else-if="
                      key === 'mode' &&
                      row.rowStatus === 'edit' &&
                      (row['port'][0] === 'e' || row['port'][0] === 'E')
                    "
                  >
                    <select
                      class="form-control table-edit"
                      v-model="row['newmode']"
                    >
                      <option
                        v-for="(value, key) in ['access', 'hybrid', 'trunk']"
                        :key="key"
                        :value="value"
                      >
                        {{ value }}
                      </option>
                    </select>
                  </div>
                  <!-- 端口tag VLAN编辑 -->
                  <div
                    v-else-if="
                      key === 'tagvlan' &&
                      row.rowStatus === 'edit' &&
                      (row['port'][0] === 'e' || row['port'][0] === 'E') &&
                      row['newmode'] !== 'access'
                    "
                  >
                    <span style="position: relative; display: block">
                      <input
                        type="text"
                        v-model="row.newtagvlan"
                        class="form-control table-edit"
                        maxlength="128"
                        placeholder="all or like 1-2,4"
                      />
                      <i
                        class="form-control-feedback glyphicon"
                        style="height: 20px; line-height: 20px; width: 20px"
                      ></i>
                      <small class="help-block" style="display: none"
                        >The valid name is required</small
                      >
                    </span>
                  </div>
                  <!-- 端口untag VLAN编辑 -->
                  <div
                    v-else-if="
                      key === 'untagvlan' &&
                      row.rowStatus === 'edit' &&
                      (row['port'][0] === 'e' || row['port'][0] === 'E') &&
                      row['newmode'] === 'hybrid'
                    "
                  >
                    <span style="position: relative; display: block">
                      <input
                        type="text"
                        v-model="row.newuntagvlan"
                        class="form-control table-edit"
                        maxlength="128"
                        placeholder="all or like 1-2,4"
                      />
                      <i
                        class="form-control-feedback glyphicon"
                        style="height: 20px; line-height: 20px; width: 20px"
                      ></i>
                      <small class="help-block" style="display: none"
                        >The valid name is required</small
                      >
                    </span>
                  </div>
                  <div
                    v-else-if="key === 'link'"
                    class="fa fa-circle"
                    :style="{
                      color: row.link === 'up' ? '#32CD32' : '#FF4500',
                    }"
                  ></div>
                  <div v-else>{{ value }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </block-cntr>
      </div>
    </div>
    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "./../components/InfoBox.vue"
import { get, post } from "@/utils/http.js"
import { nonASCIIchar } from "@/utils/check.js"

export default {
  name: "portStatus",
  components: {
    BlockCntr,
    InfoBox,
  },
  data() {
    return {
      page: en.page.portstatus,
      portStatusTable: "",
      selall: false,
      iBox: {},
    }
  },
  created() {
    this.loadport()
  },
  methods: {
    loadport() {
      get("portstatus")
        .then((res) => {
          this.portStatusTable = res.data
          this.dataInit()
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },

    /* 页面数据初始化 */
    dataInit() {
      this.portStatusTable.data.forEach((element) => {
        this.$set(element, "rowStatus", "")
        this.$set(element, "selected", false)
        this.$set(element, "newdesc", element["desc"])
        this.$set(
          element,
          "newshutdown",
          element["shutdown"] === "true" ? true : false
        )
        var s = element["speed"].split("-")[0]
        this.$set(element, "newspeed", s === "auto" ? "auto" : s.slice(1))
        this.$set(element, "newpri", element["pri"])
        this.$set(element, "newpvid", element["pvid"])
        this.$set(element, "newmode", element["mode"])
        this.$set(element, "newtagvlan", element["tagvlan"])
        this.$set(element, "newuntagvlan", element["untagvlan"])
      })
      this.selall = false
    },

    /* 页面提交函数 */
    clkApply() {
      var postData = {}
      var editRows = []
      var pt = this.portStatusTable.data

      for (var v = 0; v < pt.length; v++) {
        // 单元参数再次检查
        if (
          pt[v]["rowStatus"] === "edit" &&
          (this.input_pvid_check(pt[v]) || this.input_desc_check(pt[v]))
        ) {
          this.showAlertBox("warn", "warnning", "Fix the mistake first!")
          return
        }
      }

      this.portStatusTable.data.forEach((o) => {
        if (o["rowStatus"] !== "edit") return
        var s = o["speed"].split("-")[0]
        if (
          o["newdesc"] === o["desc"] &&
          o["newshutdown"] === (o["shutdown"] === "true" ? true : false) &&
          o["newspeed"] == (s === "auto" ? "auto" : s.slice(1)) &&
          o["newpri"] == o["pri"] &&
          o["newpvid"] == o["pvid"] &&
          o["newmode"] === o["mode"] &&
          o["newtagvlan"] === o["tagvlan"] &&
          o["newuntagvlan"] === o["untagvlan"]
        )
          return

        var row = { port: o["port"] }
        if (o["newdesc"] !== o["desc"]) row["desc"] = o["newdesc"]
        if (o["newshutdown"] !== (o["shutdown"] === "true" ? true : false))
          row["shutdown"] = o["newshutdown"]
        var s = o["speed"].split("-")[0]
        if (o["newspeed"] != (s === "auto" ? "auto" : s.slice(1)))
          row["speed"] = o["newspeed"]
        if (o["newpri"] != o["pri"]) row["pri"] = o["newpri"]
        if (o["newpvid"] != o["pvid"]) row["pvid"] = o["newpvid"]
        if (o["newmode"] !== o["mode"]) row["mode"] = o["newmode"]
        if (
          o["newmode"] !== "access" &&
          (o["newtagvlan"] !== o["tagvlan"] || o["newmode"] !== o["mode"])
        )
          row["tagvlan"] = o["newtagvlan"].replace(/\s/g, "")
        if (o["newmode"] === "hybrid" && o["newuntagvlan"] !== o["untagvlan"])
          row["untagvlan"] = o["newuntagvlan"].replace(/\s/g, "")
        editRows.push(row)
      })

      if (!editRows.length) {
        this.showAlertBox("info", "info", "Nothing to do!")
        return
      }
      postData["edit"] = editRows
      post("portconfig", postData)
        .then((res) => {
          if (
            res.data.code === undefined ||
            (res.data.code === 0 && res.data.msg === undefined)
          )
            this.showAlertBox("info", "Info", "Config Successful!")
          else
            this.showAlertBox(
              res.data.code === 0 ? "info" : "warn",
              res.data.code === 0 ? "Info" : "Warn",
              res.data.msg !== undefined ? res.data.msg : "Unknow error!"
            )
          this.loadport()
          window.setTimeout(this.loadport, 1500)
          window.setTimeout(this.loadport, 6000)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },

    /* 页面恢复函数 */
    clkCancel() {
      this.dataInit()
    },

    /* 参数输入检查 */
    input_desc_check(row) {
      if (row["newdesc"] == row["desc"]) return null

      return nonASCIIchar(row["newdesc"])
    },
    input_pvid_check(row) {
      if (row["port"][0] !== "e" && row["port"][0] !== "E") return null
      if (row["newpvid"] == row["pvid"]) return null

      this.$set(row, "newpvid", parseInt(row["newpvid"]))
      if (isNaN(row["newpvid"])) row["newpvid"] = 0
      if (row["newpvid"] < 1 || row["newpvid"] > 4094)
        return "The effective PVID is 1-4094."

      return null
    },

    /* 双击编辑行 */
    editDoubleClickRow(row) {
      if (row["rowStatus"] === "") {
        row["rowStatus"] = "edit"
        row["selected"] = false
      }
    },

    /* 编辑选择的行 */
    editSelectRow() {
      this.portStatusTable.data.forEach((element) => {
        if (element["rowStatus"] === "" && element["selected"]) {
          element["rowStatus"] = "edit"
          element["selected"] = false
        }
      })
    },

    /* 撤销行操作 */
    undoRow(row) {
      if (row["rowStatus"] === "edit") {
        row["rowStatus"] = ""
        row["selected"] = false
      }
    },

    /* 选择全部行 */
    selectall() {
      this.portStatusTable.data.forEach((element) => {
        if (element["rowStatus"] === "") element["selected"] = this.selall
      })
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>